import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import User from "@mapmycustomers/shared/types/User";

import DealListModalForClosedStages from "@app/component/DealListModalForCharts";
import { fetchDealsByStage } from "@app/scene/reports/store/actions";
import FunnelStatsData from "@app/scene/reports/store/FunnelStatsData";
import { getFunnelsStatsData } from "@app/scene/reports/store/selectors";
import { RootState } from "@app/store/rootReducer";
import isClosedStage from "@app/util/isClosedStage";

import useChartConfig from "./useChartConfig";

interface Props {
  chartTitle: string;
  funnel: Funnel | undefined;
  funnelsStatsData: FunnelStatsData;
  lost: number;
  userIds: Array<User["id"]>;
  whichConfigToUse: string;
  won: number;
}

const WonLossPieChart: React.FC<
  Props & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>
> = ({ chartTitle, funnel, funnelsStatsData, lost, userIds, whichConfigToUse, won }) => {
  const [selectedStage, setSelectedStage] = useState<Stage | undefined>(undefined);

  const handleSelectStage = useCallback(
    (stage: Stage) => {
      setSelectedStage(stage);
    },
    [setSelectedStage]
  );

  const options = useChartConfig(
    funnelsStatsData.stageSummary,
    chartTitle,
    handleSelectStage,
    lost,
    won,
    whichConfigToUse
  );

  return (
    <>
      {!!options && <HighchartsReact highcharts={Highcharts} immutable options={options} />}
      {selectedStage && isClosedStage(selectedStage) && (
        <DealListModalForClosedStages
          funnelName={funnel?.name}
          onHide={() => setSelectedStage(undefined)}
          stage={selectedStage}
          userIds={userIds}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  funnelsStatsData: getFunnelsStatsData(state),
});

const mapDispatchToProps = {
  fetchDealsByStageId: fetchDealsByStage.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(WonLossPieChart);
